import getApiCallerAction from 'src/utils/apiClientCaller';
import useAlert from './useAlert';
import useActionCreators from './useActionCreators';

function useApiCaller() {
  const { showAlert } = useAlert();
  const { getApiCaller } = useActionCreators({
    getApiCaller: getApiCallerAction,
  });
  return getApiCaller(showAlert);
}

export default useApiCaller;
